/** Define all validation rules separated by feature */
export namespace CustomerEnum {
  export const gender = Object.freeze({
    male: 'male',
    female: 'female',
    other: 'other',
  });

  export const member = Object.freeze({
    clubCardMember: 1,
    nonClubCard: 2,
  });

  export const voucherStatus = Object.freeze({
    active: 'active',
    reserve: 'reserve',
    used: 'used',
  });

  export const questionnaireStatus = Object.freeze({
    pending: 'pending',
    done: 'done',
  });

  export const questionnaireStep = Object.freeze({
    pending: 'PENDING',
    completed: 'COMPLETED',

  });

  export const customerUpdateType = Object.freeze({
    deactivate: 'deactivate',
    activate: 'activate',
    sendForgotPasswordLink: 'sendForgotPasswordLink',
  });

  export const memberType = Object.freeze({
    nonClubCard: 'Non-club card',
    clubCard: 'Club card',
  });
}
